import React, { useEffect, useState } from "react";
import {
  AddButton,
  CustomConfirmModal,
  PaginationDropdown,
  ThinDropdownWithSearch,
  ThinTextField,
} from "../common/GeneralComponent";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import {
  ChevronsRightIcon,
  Edit,
  Trash,
  Minus,
  Plus,
  Download,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setExporting } from "../../slices/exportSlice";
import { logout } from "../../slices/authSlice";
import DataTable from "react-data-table-component";
import { Pagination } from "@mui/material";
import { fetchData } from "../../utils/functions";
import "font-awesome/css/font-awesome.min.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import GeneralFooter from "../common/GeneralFooter";
import PermissionButton from "../common/PermissionButton";

const HouseHold = () => {
  const dispatch = useDispatch();
  const isExporting = useSelector(
    (state) => state.export?.isExporting || false
  );
  const navigate = useNavigate();
  const { user: loggedInUser } = useSelector((state) => state.auth);
  const permissions = loggedInUser?.user_permissions || [];
  const [rolesData, setRolesData] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isModalVisible, setModalVisible] = useState(false);
  const [isApproveModalVisible, setApproveModalVisible] = useState(false);
  const [isRejectModalVisible, setRejectModalVisible] = useState(false);
  const [isRemarksModalVisible, setRemarksModalVisible] = useState(false);
  const [isViewRemarksModalVisible, setViewRemarksModalVisible] =
    useState(false);
  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState("");
  const [selectedUuid, setSelectedUuid] = useState(null);
  const [selectedApproveId, setSelectedApproveId] = useState(null);
  const [selectedRejectId, setSelectedRejectId] = useState(null);
  const [selectedHouseholdForRemarks, setSelectedHouseholdForRemarks] =
    useState(null);
  const [isFiltersVisible, setIsFiltersVisible] = useState(false);
  const [filterReset, setFilterReset] = useState(0);
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [appliedDistrict, setAppliedDistrict] = useState(null);
  const [tehsils, setTehsils] = useState([]);
  const [selectedTehsil, setSelectedTehsil] = useState(null);
  const [appliedTehsil, setAppliedTehsil] = useState(null);
  const [ucs, setUcs] = useState([]);
  const [selectedUc, setSelectedUc] = useState(null);
  const [appliedUc, setAppliedUc] = useState(null);
  const [dehs, setDehs] = useState([]);
  const [selectedDeh, setSelectedDeh] = useState(null);
  const [appliedDeh, setAppliedDeh] = useState(null);
  const [villages, setVillages] = useState([]);
  const [selectedVillages, setSelectedVillages] = useState(null);
  const [appliedVillages, setAppliedVillages] = useState(null);
  const [selectedDqaStatus, setSelectedDqaStatus] = useState(null);
  const [appliedDqaStatus, setAppliedDqaStatus] = useState(null);
  const [selectedSurveyType, setSelectedSurveyType] = useState(null);
  const [appliedSurveyType, setAppliedSurveyType] = useState(null);
  const [dateField, setDateField] = useState("");
  const [condition, setCondition] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [appliedDateField, setAppliedDateField] = useState(null);
  const [appliedCondition, setAppliedCondition] = useState(null);
  const [appliedDateValue, setAppliedDateValue] = useState(null);
  const [appliedStartDate, setAppliedStartDate] = useState(null);
  const [appliedEndDate, setAppliedEndDate] = useState(null);

  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
    total_records: 0,
    total_pages: 0,
  });

  const hasFiltersApplied =
    appliedDistrict ||
    appliedTehsil ||
    appliedUc ||
    appliedDeh ||
    appliedVillages ||
    appliedCondition ||
    appliedDqaStatus ||
    appliedSurveyType;

  const hasDataToExport = rolesData.length > 0;

  const dateFieldsOptions = [
    { value: "date_of_interview", label: "Date of Interview" },
  ];

  const dqaStatusOptions = [
    { value: "0", label: "Pending" },
    { value: "1", label: "Approved" },
    { value: "2", label: "Rejected" },
  ];

  const surveyTypeOptions = [
    { value: "Baseline", label: "Baseline" },
    { value: "Midline", label: "Midline" },
    { value: "Endline", label: "Endline" },
  ];

  const conditions = [
    { value: "lt", label: "Less Than" },
    { value: "gt", label: "Greater Than" },
    { value: "equals", label: "Equal To" },
    { value: "between", label: "Between" },
  ];

  const getLatestRemarks = (household) => {
    if (household.auditLogs && household.auditLogs.length > 0) {
      try {
        const latestAudit = household.auditLogs[0];
        const newValue = JSON.parse(latestAudit.newvalue);
        return newValue.remarks || household.remarks || "No remarks";
      } catch (error) {
        console.warn("Failed to parse audit log:", error);
        return household.remarks || "No remarks";
      }
    }
    return household.remarks || "No remarks";
  };

  const getRemarksHistory = (household) => {
    if (!household.auditLogs || household.auditLogs.length === 0) {
      return [];
    }
    const history = [];
    household.auditLogs.forEach((log, index) => {
      try {
        const newValue = JSON.parse(log.newvalue);
        const oldValue = log.oldvalue ? JSON.parse(log.oldvalue) : null;

        history.push({
          action: log.action,
          date: log.createdAt,
          from: oldValue?.remarks || "None",
          to: newValue.remarks,
          userId: log.userId,
          userName: log.userName,
        });
      } catch (error) {
        console.warn("Failed to parse audit log:", error);
      }
    });

    return history;
  };

  const showRemarksDialog = (household) => {
    setSelectedHouseholdForRemarks(household);
    setViewRemarksModalVisible(true);
  };

  const closeRemarksDialog = () => {
    setViewRemarksModalVisible(false);
    setSelectedHouseholdForRemarks(null);
  };

  const validateRemarks = (remarksText) => {
    if (!remarksText.trim()) {
      return "Remarks are required";
    }
    if (remarksText.trim().length < 10) {
      return "Remarks must be at least 10 characters long";
    }
    if (remarksText.trim().length > 255) {
      return "Remarks cannot exceed 255 characters";
    }
    return "";
  };

  const handleRemarksChange = (value) => {
    setRemarks(value);
    if (remarksError) {
      const error = validateRemarks(value);
      setRemarksError(error);
    }
  };

  const toggleFilters = () => {
    setIsFiltersVisible((prev) => !prev);
  };

  const handleApply = () => {
    if (condition && !dateField) {
      toast.error("Please select a date field when using a condition");
      return;
    }

    if (condition === "between") {
      if (!startDate || !endDate) {
        toast.error(
          "Please provide both start and end dates for 'between' condition"
        );
        return;
      }
    }

    if (condition && condition !== "between" && !dateValue) {
      toast.error("Please provide a date value for the selected condition");
      return;
    }

    setAppliedDistrict(selectedDistrict);
    setAppliedTehsil(selectedTehsil);
    setAppliedUc(selectedUc);
    setAppliedDeh(selectedDeh);
    setAppliedVillages(selectedVillages);
    setAppliedDqaStatus(selectedDqaStatus);
    setAppliedSurveyType(selectedSurveyType);
    setAppliedDateField(dateField);
    setAppliedCondition(condition);
    if (condition === "between") {
      setAppliedStartDate(startDate);
      setAppliedEndDate(endDate);
      setAppliedDateValue(null);
    } else {
      setAppliedDateValue(dateValue);
      setAppliedStartDate(null);
      setAppliedEndDate(null);
    }
    setPagination((prev) => ({ ...prev, current_page: 1 }));
  };

  const handleClear = () => {
    setSelectedDistrict(null);
    setSelectedTehsil(null);
    setSelectedUc(null);
    setSelectedDeh(null);
    setSelectedVillages(null);
    setSelectedDqaStatus(null);
    setSelectedSurveyType(null);
    setAppliedDistrict(null);
    setAppliedTehsil(null);
    setAppliedUc(null);
    setAppliedDeh(null);
    setAppliedVillages(null);
    setAppliedDqaStatus(null);
    setAppliedSurveyType(null);
    setAppliedDateField(null);
    setAppliedCondition(null);
    setAppliedDateValue(null);
    setAppliedStartDate(null);
    setAppliedEndDate(null);
    setDateField("");
    setCondition("");
    setDateValue("");
    setStartDate("");
    setEndDate("");
    setTehsils([]);
    setUcs([]);
    setDehs([]);
    setVillages([]);
    setPagination((prev) => ({ ...prev, current_page: 1 }));
    setFilterReset((prev) => prev + 1);
  };

  const handleDistrictChange = (selected) => {
    setSelectedDistrict(selected);
    setSelectedTehsil(null);
    setSelectedUc(null);
    setSelectedDeh(null);
    setSelectedVillages(null);
    setTehsils([]);
    setUcs([]);
    setDehs([]);
    setVillages([]);
  };

  const handleTehsilChange = (selected) => {
    setSelectedTehsil(selected);
    setSelectedUc(null);
    setSelectedDeh(null);
    setSelectedVillages(null);
    setUcs([]);
    setDehs([]);
    setVillages([]);
  };

  const handleUcChange = (selected) => {
    setSelectedUc(selected);
    setSelectedDeh(null);
    setSelectedVillages(null);
    setDehs([]);
    setVillages([]);
  };

  const handleDehChange = (selected) => {
    setSelectedDeh(selected);
    setSelectedVillages(null);
    setVillages([]);
  };

  const handleVillageChange = (selected) => {
    setSelectedVillages(selected);
  };

  const handleFilterChange = (key, value) => {
    switch (key) {
      case "dateField":
        setDateField(value);
        if (value === "") {
          setCondition("");
          setDateValue("");
          setStartDate("");
          setEndDate("");
        }
        break;
      case "condition":
        setCondition(value);
        if (value !== "between") {
          setStartDate("");
          setEndDate("");
        } else {
          setDateValue("");
        }
        break;
      default:
        break;
    }
  };

  const formatDateForExport = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear());

    return `${day}/${month}/${year}`;
  };

  const fetchDistricts = async () => {
    try {
      const response = await fetchData(
        "districts",
        "GET",
        null,
        {},
        {},
        navigate,
        "/districts",
        dispatch
      );
      setDistricts(response?.data || []);
    } catch (error) {
      console.error("Error fetching districts:", error);
    }
  };

  const fetchTehsils = async () => {
    if (!selectedDistrict) return;
    try {
      const response = await fetchData(
        "tehsils",
        "GET",
        null,
        {},
        { district_id: selectedDistrict },
        navigate,
        "/tehsils",
        dispatch
      );
      setTehsils(response?.data || []);
    } catch (error) {
      console.error("Error fetching tehsils:", error);
    }
  };

  const fetchUcs = async () => {
    if (!selectedTehsil) return;
    try {
      const response = await fetchData(
        "ucs",
        "GET",
        null,
        {},
        { tehsil_id: selectedTehsil },
        navigate,
        "/ucs",
        dispatch
      );
      setUcs(response?.data || []);
    } catch (error) {
      console.error("Error fetching UCs:", error);
    }
  };

  const fetchDehs = async () => {
    if (!selectedTehsil) return;
    try {
      const response = await fetchData(
        "dehs",
        "GET",
        null,
        {},
        { tehsil_id: selectedTehsil },
        navigate,
        "/dehs",
        dispatch
      );
      setDehs(response?.data || []);
    } catch (error) {
      console.error("Error fetching Dehs:", error);
    }
  };

  const fetchVillages = async () => {
    if (!selectedDeh) return;
    try {
      const response = await fetchData(
        "villages",
        "GET",
        null,
        {},
        { deh_id: selectedDeh },
        navigate,
        "/villages",
        dispatch
      );
      setVillages(response?.data || []);
    } catch (error) {
      console.error("Error fetching Villages:", error);
    }
  };

  const fetchRoles = async () => {
    try {
      const response = await fetchData(
        "householdinformation",
        "GET",
        null,
        {},
        {
          page: pagination.current_page,
          limit: pagination.per_page,
          search: debouncedSearch || undefined,
          district_id: appliedDistrict || undefined,
          tehsil_id: appliedTehsil || undefined,
          uc_id: appliedUc || undefined,
          deh_id: appliedDeh || undefined,
          village_id: appliedVillages || undefined,
          date_field: appliedDateField || undefined,
          condition: appliedCondition || undefined,
          date_value: appliedDateValue || undefined,
          start_date: appliedStartDate || undefined,
          end_date: appliedEndDate || undefined,
          verified_from_dqa: appliedDqaStatus || undefined,
          survey_type: appliedSurveyType || undefined,
        },
        navigate,
        "/role",
        dispatch
      );

      const sortedData = (response?.data?.household_information || []).sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      setRolesData(sortedData);
      setPagination(response?.data?.pagination || {});
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const fetchAllHouseholdsForExport = async () => {
    try {
      const response = await fetchData(
        "householdinformation",
        "GET",
        null,
        {},
        {
          page: 1,
          limit: 10000,
          search: debouncedSearch || undefined,
          district_id: appliedDistrict || undefined,
          tehsil_id: appliedTehsil || undefined,
          uc_id: appliedUc || undefined,
          deh_id: appliedDeh || undefined,
          village_id: appliedVillages || undefined,
          date_field: appliedDateField || undefined,
          condition: appliedCondition || undefined,
          date_value: appliedDateValue || undefined,
          start_date: appliedStartDate || undefined,
          end_date: appliedEndDate || undefined,
          dqa_status: appliedDqaStatus || undefined,
          survey_type: appliedSurveyType || undefined,
        },
        navigate,
        "/role",
        dispatch
      );

      return response?.data?.household_information || [];
    } catch (error) {
      console.error("Error fetching all households:", error);
      return [];
    }
  };

  const fetchDetailedHouseholdData = async (householdIds) => {
    const detailedData = [];

    for (const id of householdIds) {
      try {
        const response = await fetchData(
          `householdinformation/${id}`,
          "GET",
          null,
          {},
          {},
          navigate,
          "/household",
          dispatch
        );

        if (response?.data) {
          detailedData.push(response.data);
        }
      } catch (error) {
        console.error(
          `Error fetching detailed data for household ${id}:`,
          error
        );
      }
    }

    return detailedData;
  };

  const getGender = (gender) => {
    switch (parseInt(gender)) {
      case 1:
        return "Male";
      case 2:
        return "Female";
      default:
        return gender || "N/A";
    }
  };

  const handleExport = () => {
    if (isExporting) {
      toast.warning("Export is already in progress. Please wait.");
      return;
    }

    dispatch(setExporting(true));

    try {
      const params = new URLSearchParams();
      if (debouncedSearch) params.append("search", debouncedSearch);
      if (appliedDistrict) params.append("district_id", appliedDistrict);
      if (appliedTehsil) params.append("tehsil_id", appliedTehsil);
      if (appliedUc) params.append("uc_id", appliedUc);
      if (appliedDeh) params.append("deh_id", appliedDeh);
      if (appliedVillages) params.append("village_id", appliedVillages);
      if (appliedDateField) params.append("date_field", appliedDateField);
      if (appliedCondition) params.append("condition", appliedCondition);
      if (appliedDateValue) params.append("date_value", appliedDateValue);
      if (appliedStartDate) params.append("start_date", appliedStartDate);
      if (appliedEndDate) params.append("end_date", appliedEndDate);
      if (appliedDqaStatus) params.append("dqa_status", appliedDqaStatus);
      if (appliedSurveyType) params.append("survey_type", appliedSurveyType);

      const BASE_URL =
        process.env.REACT_APP_BASE_URL || "http://localhost:8000";
      const token = localStorage.getItem("token");

      if (!token) {
        dispatch(setExporting(false));
        toast.error("Authentication token not found. Please login again.");
        return;
      }

      toast.info("Starting export... Please wait.", {
        autoClose: 3000,
      });

      fetch(
        `${BASE_URL}/api/householdinformation/export?${params.toString()}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "text/csv",
          },
        }
      )
        .then(async (response) => {
          if (!response.ok) {
            if (response.status === 401 || response.status === 403) {
              dispatch(logout());
              navigate("/login");
              const contentType = response.headers.get("content-type");
              if (contentType && contentType.includes("application/json")) {
                const errorData = await response.json();
                throw new Error(
                  errorData.message || "Session expired. Please login again."
                );
              }
              throw new Error("Session expired. Please login again.");
            }
            const contentType = response.headers.get("content-type") || "";
            const errorData = contentType.includes("application/json")
              ? await response.json().catch(() => ({}))
              : {};
            const error = new Error(
              errorData.message || `Export failed with status: ${response.status}`
            );
            error.noRecords = response.status === 400;
            throw error;
          }
          return response.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `household_export_${
            new Date().toISOString().split("T")[0]
          }.csv`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          toast.success("Export completed successfully!");
        })
        .catch((error) => {
          if (error.noRecords) {
            toast.info(error.message);
            return;
          }
          console.error("Error during export:", error);
          toast.error(error.message || "Failed to export data.");
        })
        .finally(() => {
          dispatch(setExporting(false));
        });
    } catch (error) {
      console.error("Error initiating export:", error);
      toast.error(error.message || "Failed to initiate export.");
      dispatch(setExporting(false));
    }
  };

  useEffect(() => {
    fetchDistricts();
  }, []);

  useEffect(() => {
    fetchTehsils();
  }, [selectedDistrict]);

  useEffect(() => {
    fetchUcs();
  }, [selectedTehsil]);

  useEffect(() => {
    fetchDehs();
  }, [selectedTehsil]);

  useEffect(() => {
    fetchVillages();
  }, [selectedDeh]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (search === debouncedSearch) return;
      setDebouncedSearch(search);
      setPagination((prev) => ({ ...prev, current_page: 1 }));
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    fetchRoles();
  }, [
    appliedDistrict,
    appliedTehsil,
    appliedUc,
    appliedDeh,
    appliedVillages,
    appliedDqaStatus,
    appliedSurveyType,
    appliedDateField,
    appliedCondition,
    appliedDateValue,
    appliedStartDate,
    appliedEndDate,
    debouncedSearch,
    pagination.current_page,
    pagination.per_page,
  ]);

  const handlePageSizeChange = (size) => {
    setPagination((prev) => ({ ...prev, per_page: size, current_page: 1 }));
  };

  const handlePageChange = (event, value) => {
    setPagination((prev) => ({ ...prev, current_page: value }));
  };

  const handleDelete = async () => {
    setModalVisible(false);
    setRolesData((prev) =>
      prev.filter(
        (houseHold) => houseHold.household_information_id !== selectedUuid
      )
    );
    try {
      const response = await fetchData(
        `householdinformation-delete/${selectedUuid}`,
        "DELETE",
        { id: selectedUuid },
        {},
        {},
        navigate,
        "/household",
        dispatch
      );

      if (!response?.success) {
        throw new Error(response?.message || "Failed to delete the household.");
      }
      toast.success("Household deleted successfully.");
    } catch (error) {
      console.error("Error deleting household:", error);
      toast.error(
        error?.message || "An error occurred while deleting the household."
      );
      fetchRoles();
    }
  };

  const handleApprove = async () => {
    setApproveModalVisible(false);
    try {
      const response = await fetchData(
        `householdinformation-approve/${selectedApproveId}`,
        "PUT",
        {},
        {},
        {},
        navigate,
        "/household",
        dispatch
      );

      if (!response?.success) {
        throw new Error(
          response?.message || "Failed to approve the household."
        );
      }

      toast.success("Household approved successfully.");

      const currentDateTime = new Date().toISOString();
      setRolesData((prev) =>
        prev.map((item) =>
          item.household_information_id === selectedApproveId
            ? {
                ...item,
                verified_from_dqa: 1,
                verfied_from_dqa_datetime: currentDateTime,
              }
            : item
        )
      );
    } catch (error) {
      console.error("Error approving household:", error);
      toast.error(
        error?.message || "An error occurred while approving the household."
      );
    }
  };

  const handleReject = async () => {
    setRejectModalVisible(false);
    setRemarksModalVisible(true);
  };

  const handleSubmitRemarks = async () => {
    const validationError = validateRemarks(remarks);
    if (validationError) {
      setRemarksError(validationError);
      return;
    }

    try {
      const response = await fetchData(
        `householdinformation-reject/${selectedRejectId}`,
        "PUT",
        {
          result_of_interview: "Ongoing/ Continue",
          verified_from_dqa_status: 2,
          remarks: remarks.trim(),
        },
        {},
        {},
        navigate,
        "/household",
        dispatch
      );

      if (!response?.success) {
        throw new Error(response?.message || "Failed to reject the household.");
      }

      toast.success("Household rejected successfully.");

      const currentDateTime = new Date().toISOString();

      setRolesData((prev) =>
        prev.map((item) =>
          item.household_information_id === selectedRejectId
            ? {
                ...item,
                verified_from_dqa: 2,
                verfied_from_dqa_datetime:
                  response.data?.verfied_from_dqa_datetime ||
                  new Date().toISOString(),
                rejection_remarks: remarks.trim(),
              }
            : item
        )
      );
      // Auto reload the listing
      await fetchRoles();

      setRemarksModalVisible(false);
      setRemarks("");
      setRemarksError("");
    } catch (error) {
      console.error("Error rejecting household:", error);
      toast.error(
        error?.message || "An error occurred while rejecting the household."
      );
    }
  };

  const handleCancelRemarks = () => {
    setRemarksModalVisible(false);
    setRemarks("");
    setRemarksError("");
  };

  const showDeleteModal = (id) => {
    setSelectedUuid(id);
    setModalVisible(true);
  };

  const showApproveModal = (id) => {
    setSelectedApproveId(id);
    setApproveModalVisible(true);
  };

  const showRejectModal = (id) => {
    setSelectedRejectId(id);
    setRejectModalVisible(true);
  };

  const formatInterviewDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const formatApprovalDateTime = (dateTimeString) => {
    if (!dateTimeString) return null;

    const date = new Date(dateTimeString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDateTimeForDisplay = (dateTimeString) => {
    if (!dateTimeString) return "N/A";

    const date = new Date(dateTimeString);
    if (isNaN(date)) return "N/A";

    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      hour12: true,
      timeZone: "Asia/Karachi",
    });
  };

  const toggleStatus = async (householdId, newStatus) => {
    try {
      const response = await fetchData(
        `householdinformation-status/${householdId}`,
        "PUT",
        { status: newStatus },
        {},
        {},
        navigate,
        "/household",
        dispatch
      );
      if (!response?.success) {
        throw new Error(response?.message || "Failed to update status.");
      }

      setRolesData((prevHouseholds) =>
        prevHouseholds.map((household) =>
          household.household_information_id === householdId
            ? { ...household, status: newStatus }
            : household
        )
      );

      toast.success("Status updated successfully.");
    } catch (error) {
      console.error("Status update error:", error);
      toast.error(error?.message || "An error occurred while updating status.");
    }
  };

  const surveyTypeBadge = (type) => {
    if (!type) return <span className="text-gray-400 text-xs">—</span>;
    const styles =
      type === "Baseline"
        ? "bg-blue-100 text-blue-800"
        : type === "Midline"
        ? "bg-yellow-100 text-yellow-800"
        : "bg-purple-100 text-purple-800";
    return (
      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${styles}`}>
        {type}
      </span>
    );
  };

  const columns = [
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          Household Number
        </span>
      ),
      selector: (row) => row.household_number || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          Survey Type
        </span>
      ),
      cell: (row) => surveyTypeBadge(row.survey_type),
      sortable: true,
      selector: (row) => row.survey_type || "",
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          Head Name
        </span>
      ),
      selector: (row) => row.hh_head_name || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">Village</span>
      ),
      selector: (row) => row.village_name || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          Date of Interview
        </span>
      ),
      selector: (row) => formatInterviewDate(row.date_time_of_interview),
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          DQA Approval
        </span>
      ),
      cell: (row) => {
        const isApproved =
          row.verified_from_dqa === 1 || row.verified_from_dqa === "1";
        const isRejected =
          row.verified_from_dqa === 2 || row.verified_from_dqa === "2";
        const approvalDateTime = formatApprovalDateTime(
          row.verfied_from_dqa_datetime
        );
        const rejectionDateTime = formatApprovalDateTime(
          row.verfied_from_dqa_datetime
        );

        return (
          <div className="text-center">
            {isApproved ? (
              <>
                <span className="py-1 px-2 text-[0.75rem] rounded-full font-semibold bg-blue-100 text-blue-800">
                  Approved
                </span>
                {approvalDateTime && (
                  <div className="text-[0.65rem] text-gray-600 mt-2">
                    {approvalDateTime}
                  </div>
                )}
              </>
            ) : isRejected ? (
              <>
                <span className="py-1 px-2 text-[0.75rem] rounded-full font-semibold bg-red-100 text-red-800">
                  Rejected
                </span>
                {rejectionDateTime && (
                  <div className="text-[0.65rem] text-gray-600 mt-2">
                    {rejectionDateTime}
                  </div>
                )}
              </>
            ) : (
              <span className="py-1 px-2 text-[0.75rem] rounded-full font-semibold bg-yellow-100 text-yellow-800 ml-6">
                Pending
              </span>
            )}
          </div>
        );
      },
    },
  ];

  if (
    permissions.includes("household-information-update") ||
    permissions.includes("household-information-approve") ||
    permissions.includes("household-information-reject") ||
    permissions.includes("household-information-delete")
  ) {
    columns.push({
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">Action</span>
      ),
      cell: (row) => {
        const isApproved =
          row.verified_from_dqa === 1 || row.verified_from_dqa === "1";
        const isRejected =
          row.verified_from_dqa === 2 || row.verified_from_dqa === "2";
        const hasRemarks = getLatestRemarks(row) !== "No remarks";
        // approved or rejected records open read-only
        const isReadOnly = isApproved || isRejected;

        return (
          <div className="flex gap-2">
            {hasRemarks && (
              <button
                onClick={() => showRemarksDialog(row)}
                title="View Remarks"
                className="text-blue-600 hover:text-blue-800 hover:scale-110 transition-transform"
              >
                <i className="fa-solid fa-comment fa-lg"></i>
              </button>
            )}

            <PermissionButton
              hasPermission={permissions.includes(
                "household-information-update"
              )}
              to={`/household/edit/${row.household_information_id}`}
              faIcon={
                isReadOnly
                  ? "fa-solid fa-eye fa-lg"
                  : "fa-solid fa-pen-to-square fa-lg"
              }
              onlyIcon
              enabledClass=""
              disabledClass="opacity-50 cursor-not-allowed"
            />
            {permissions.includes("household-information-approve") &&
              !isApproved &&
              !isRejected && (
                <button
                  onClick={() => showApproveModal(row.household_information_id)}
                  title="Approve"
                  className="hover:scale-110 transition-transform"
                >
                  <i className="fa-solid fa-check-circle fa-lg text-green-600 hover:text-green-800"></i>
                </button>
              )}
            {permissions.includes("household-information-reject") &&
              !isApproved &&
              !isRejected && (
                <button
                  onClick={() => showRejectModal(row.household_information_id)}
                  title="Reject"
                  className="hover:scale-110 transition-transform"
                >
                  <i className="fa-solid fa-times-circle fa-lg text-red-600 hover:text-red-800"></i>
                </button>
              )}
            {permissions.includes("household-information-delete") &&
              !isApproved && (
                <PermissionButton
                  hasPermission={permissions.includes(
                    "household-information-delete"
                  )}
                  faIcon="fa fa-trash fa-lg text-primaryDark"
                  onlyIcon
                  onClick={() => showDeleteModal(row.household_information_id)}
                  className="p-1 rounded-full bg-gray-200 text-[#137e81] hover:text-white"
                  enabledClass=""
                  disabledClass="opacity-50 cursor-not-allowed bg-gray-300"
                />
              )}
          </div>
        );
      },
    });
  }

  const customStyles = {
    headCells: {
      style: {
        border: "1px solid #f3f3f3",
        backgroundColor: "#fff",
        color: "black",
        fontWeight: "bold",
        fontSize: "1.075rem",
        textAlign: "center",
      },
    },
    cells: {
      style: {
        border: "1px solid #f3f3f3",
        textAlign: "center",
      },
    },
  };

  return (
    <div>
      <div className="my-4 flex justify-between items-center">
        <h1 className="text-[1.475rem] text-[#212529] font-[Bold]">
          Household Information
        </h1>

        {hasDataToExport && (
          <button
            onClick={handleExport}
            disabled={isExporting}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all ${
              isExporting
                ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                : "bg-[#137e81] text-white hover:bg-[#0f6c6f] hover:scale-105"
            }`}
            title="Export filtered data to Excel"
          >
            <Download size={18} />
            {isExporting ? "Exporting..." : "Export Excel"}
          </button>
        )}
      </div>

      {/* <Accordion>
        <AccordionSummary
          expandIcon={
            isFiltersVisible ? (
              <Minus color="#ffff" size={14} />
            ) : (
              <Plus size={14} color="#ffff" />
            )
          }
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{
            backgroundColor: "#137e81",
            color: "#fff !important",
            "& .MuiAccordionSummary-content": {
              color: "#fff  !important",
            },
          }}
          onClick={toggleFilters}
        >
          Filters
        </AccordionSummary>
        <AccordionDetails>
          <div className="space-y-4">
            <div className="flex gap-5 w-full">
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`district-${filterReset}`}
                  label="District"
                  id="district-dropdown"
                  options={districts?.map((dis) => ({
                    value: dis?.district_id,
                    label: dis?.district_name,
                  }))}
                  value={selectedDistrict}
                  onChange={handleDistrictChange}
                />
              </div>
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`tehsil-${filterReset}`}
                  label="Tehsil"
                  id="tehsil-dropdown"
                  options={tehsils?.map((tehsil) => ({
                    value: tehsil?.tehsil_id,
                    label: tehsil?.tehsil_name,
                  }))}
                  value={selectedTehsil}
                  onChange={handleTehsilChange}
                />
              </div> */}
      {/* <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`uc-${filterReset}`}
                  label="UC"
                  id="uc-dropdown"
                  options={ucs?.map((uc) => ({
                    value: uc?.uc_id,
                    label: uc?.uc_name,
                  }))}
                  value={selectedUc}
                  onChange={handleUcChange}
                />
              </div> */}
      {/* <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`deh-${filterReset}`}
                  label="Deh"
                  id="deh-dropdown"
                  options={dehs?.map((deh) => ({
                    value: deh?.deh_id,
                    label: deh?.deh_name,
                  }))}
                  value={selectedDeh}
                  onChange={handleDehChange}
                />
              </div>
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`village-${filterReset}`}
                  label="Village"
                  id="village-dropdown"
                  options={villages?.map((Village) => ({
                    value: Village?.village_id,
                    label: Village?.village_name,
                  }))}
                  value={selectedVillages}
                  onChange={handleVillageChange}
                />
              </div>
            </div>

            <div className="flex gap-5 w-full">
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  label="DQA Status"
                  id="dqa-status-dropdown"
                  options={dqaStatusOptions}
                  value={selectedDqaStatus}
                  onChange={(value) => setSelectedDqaStatus(value)}
                />
              </div>

              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  label="Date Field"
                  id="date-field-dropdown"
                  options={dateFieldsOptions}
                  value={dateField}
                  onChange={(value) => handleFilterChange("dateField", value)}
                />
              </div>
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  label="Condition"
                  id="condition-dropdown"
                  options={conditions}
                  value={condition}
                  onChange={(value) => handleFilterChange("condition", value)}
                  disabled={!dateField}
                />
              </div>
              {condition === "between" ? (
                <>
                  <div className="flex-1">
                    <ThinTextField isRequired={false}
                      label="Start Date"
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="flex-1">
                    <ThinTextField isRequired={false}
                      label="End Date"
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                  <div className="flex-1"></div>
                </>
              ) : (
                <>
                  <div className="flex-1">
                    <ThinTextField isRequired={false}
                      label="Date Value"
                      type="date"
                      value={dateValue}
                      onChange={(e) => setDateValue(e.target.value)}
                      disabled={!condition || condition === "between"}
                    />
                  </div>
                  <div className="flex-1"></div>
                  <div className="flex-1"></div>
                </>
              )}
            </div>
          </div>
          <div className="flex gap-2 mt-4 justify-end">
            <button
              onClick={handleClear}
              className="px-4 py-2 bg-[#be9609] text-white rounded-lg hover:bg-[#a68108] transition-colors"
            >
              Clear
            </button>
            <button
              onClick={handleApply}
              className="px-4 py-2 bg-[#137e81] text-white rounded-lg transition-colors"
            >
              Apply
            </button>
          </div> */}
      {/* </AccordionDetails>
      </Accordion> */}

      <Accordion>
        <AccordionSummary
          expandIcon={
            isFiltersVisible ? (
              <Minus color="#ffff" size={14} />
            ) : (
              <Plus size={14} color="#ffff" />
            )
          }
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{
            backgroundColor: "#137e81",
            color: "#fff !important",
            "& .MuiAccordionSummary-content": {
              color: "#fff !important",
            },
          }}
          onClick={toggleFilters}
        >
          Filters
        </AccordionSummary>

        <AccordionDetails>
          <div className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 w-full">
              <ThinDropdownWithSearch required={false}
                key={`survey-type-${filterReset}`}
                label="Survey Type"
                id="survey-type-dropdown"
                options={surveyTypeOptions}
                value={selectedSurveyType}
                onChange={(value) => setSelectedSurveyType(value)}
              />

              <ThinDropdownWithSearch required={false}
                key={`district-${filterReset}`}
                label="District"
                id="district-dropdown"
                options={districts?.map((dis) => ({
                  value: dis?.district_id,
                  label: dis?.district_name,
                }))}
                value={selectedDistrict}
                onChange={handleDistrictChange}
              />

              <ThinDropdownWithSearch required={false}
                key={`tehsil-${filterReset}`}
                label="Tehsil"
                id="tehsil-dropdown"
                options={tehsils?.map((tehsil) => ({
                  value: tehsil?.tehsil_id,
                  label: tehsil?.tehsil_name,
                }))}
                value={selectedTehsil}
                onChange={handleTehsilChange}
              />

              <ThinDropdownWithSearch required={false}
                key={`deh-${filterReset}`}
                label="Deh"
                id="deh-dropdown"
                options={dehs?.map((deh) => ({
                  value: deh?.deh_id,
                  label: deh?.deh_name,
                }))}
                value={selectedDeh}
                onChange={handleDehChange}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 w-full">
              <ThinDropdownWithSearch required={false}
                key={`village-${filterReset}`}
                label="Village"
                id="village-dropdown"
                options={villages?.map((village) => ({
                  value: village?.village_id,
                  label: village?.village_name,
                }))}
                value={selectedVillages}
                onChange={handleVillageChange}
              />

              <ThinDropdownWithSearch required={false}
                label="DQA Status"
                id="dqa-status-dropdown"
                options={dqaStatusOptions}
                value={selectedDqaStatus}
                onChange={(value) => setSelectedDqaStatus(value)}
              />

              <ThinDropdownWithSearch required={false}
                label="Date Field"
                id="date-field-dropdown"
                options={dateFieldsOptions}
                value={dateField}
                onChange={(value) => handleFilterChange("dateField", value)}
              />

              <ThinDropdownWithSearch required={false}
                label="Condition"
                id="condition-dropdown"
                options={conditions}
                value={condition}
                onChange={(value) => handleFilterChange("condition", value)}
                disabled={!dateField}
              />

              {condition === "between" ? (
                <ThinTextField isRequired={false}
                  label="Start Date"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              ) : (
                <ThinTextField isRequired={false}
                  label="Date Value"
                  type="date"
                  value={dateValue}
                  onChange={(e) => setDateValue(e.target.value)}
                  disabled={!condition}
                />
              )}
            </div>

            {condition === "between" && (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 w-full">
                <ThinTextField isRequired={false}
                  label="End Date"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
                <div></div>
                <div></div>
                <div></div>
              </div>
            )}
          </div>

          <div className="flex gap-2 mt-4 justify-end">
            <button
              onClick={handleClear}
              className="px-4 py-2 bg-[#be9609] text-white rounded-lg hover:bg-[#a68108] transition-colors"
            >
              Clear
            </button>

            <button
              onClick={handleApply}
              className="px-4 py-2 bg-[#137e81] text-white rounded-lg transition-colors"
            >
              Apply
            </button>
          </div>
        </AccordionDetails>
      </Accordion>

      <div className="rounded-lg my-[15px] shadow w-full bg-white">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
          <h1 className="text-[0.875rem] tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Manage Household Information
          </h1>

          {(hasFiltersApplied || search) && (
            <div className="text-sm text-gray-600">
              {pagination.total_records} records found
              {hasDataToExport && (
                <span className="ml-2 text-green-600 font-medium">
                  • Export available
                </span>
              )}
            </div>
          )}
        </div>
        <div className="p-[1.25rem] w-full">
          <div className="flex lg:flex-row flex-col lg:justify-between justify-start gap-2 lg:items-center items-start mb-[6px] w-full">
            <PaginationDropdown
              value={pagination.per_page}
              onChange={handlePageSizeChange}
              options={[
                { value: 10, label: "10" },
                { value: 20, label: "20" },
                { value: 30, label: "30" },
              ]}
            />

            <input
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              placeholder="Search..."
              type="search"
              className="font-[Light] text-[14px] flex items-center bg-[#f1f4f8] border-[#ebeef2] border-[1px] rounded-md px-3 py-1 outline-none"
            />
          </div>
          <DataTable
            columns={columns}
            data={rolesData}
            persistTableHead
            customStyles={customStyles}
            highlightOnHover
            progressPending={false}
          />

          <GeneralFooter
            pagination={pagination}
            handlePageChange={handlePageChange}
            handlePageSizeChange={handlePageSizeChange}
            dataLength={rolesData.length}
          />
        </div>
      </div>

      <CustomConfirmModal
        isVisible={isModalVisible}
        onConfirm={handleDelete}
        onCancel={() => setModalVisible(false)}
        message="Are you sure you want to delete this Household?"
      />

      <CustomConfirmModal
        isVisible={isApproveModalVisible}
        onConfirm={handleApprove}
        onCancel={() => setApproveModalVisible(false)}
        message="Are you sure you want to approve this Household from DQA?"
      />
      <CustomConfirmModal
        isVisible={isRejectModalVisible}
        onConfirm={handleReject}
        onCancel={() => setRejectModalVisible(false)}
        message="Are you sure you want to reject this Household from DQA?"
      />
      <Dialog
        open={isViewRemarksModalVisible}
        onClose={closeRemarksDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "8px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            maxWidth: "600px",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#137e81",
            color: "white",
            padding: "16px 24px",
            fontSize: "1.25rem",
            fontWeight: "bold",
          }}
        >
          Remarks History
          {selectedHouseholdForRemarks && (
            <Typography
              variant="subtitle1"
              sx={{ color: "white", fontSize: "0.9rem", mt: 1 }}
            >
              Household: {selectedHouseholdForRemarks.household_number} -{" "}
              {selectedHouseholdForRemarks.hh_head_name}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent sx={{ padding: "24px", maxHeight: "60vh" }}>
          {selectedHouseholdForRemarks && (
            <Box>
              <Typography variant="h6" sx={{ mb: 2, color: "#137e81" }}>
                {/* Remarks History */}
              </Typography>

              {getRemarksHistory(selectedHouseholdForRemarks).length > 0 ? (
                <Box sx={{ maxHeight: "300px", overflowY: "auto" }}>
                  {getRemarksHistory(selectedHouseholdForRemarks).map(
                    (history, index) => (
                      <Box
                        key={index}
                        sx={{
                          mb: 2,
                          p: 2,
                          border: "1px solid #e0e0e0",
                          borderRadius: "4px",
                          backgroundColor: index === 0 ? "#f0f8ff" : "white",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            mb: 1,
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: "bold", color: "#333" }}
                          ></Typography>
                          <Typography variant="caption" sx={{ color: "#666" }}>
                            {formatDateTimeForDisplay(history.date)}
                          </Typography>
                        </Box>

                        <Box sx={{ mt: 1 }}>
                          <Typography variant="body2">
                            <strong>Remarks :</strong>{" "}
                            <span
                              style={{ color: "#2e7d32", fontWeight: "bold" }}
                            >
                              {history.to ? history.to : "N/A"}
                            </span>
                          </Typography>
                        </Box>

                        <Typography
                          variant="caption"
                          sx={{ color: "#666", mt: 1, display: "block" }}
                        >
                          User Name: {history.userName}
                        </Typography>
                      </Box>
                    )
                  )}
                </Box>
              ) : (
                <Typography
                  variant="body1"
                  sx={{ textAlign: "center", color: "#666", py: 3 }}
                >
                  No remarks history available
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button
            onClick={closeRemarksDialog}
            color="primary"
            variant="contained"
            sx={{
              backgroundColor: "#137e81",
              "&:hover": {
                backgroundColor: "#0f6c6f",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isRemarksModalVisible}
        onClose={handleCancelRemarks}
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: "8px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#137e81",
            color: "white",
            padding: "16px 24px",
            fontSize: "1.25rem",
            fontWeight: "bold",
          }}
        >
          Rejection Remarks
        </DialogTitle>
        <DialogContent sx={{ padding: "24px" }}>
          <Box sx={{ marginBottom: "16px" }}>
            <Typography
              variant="body1"
              sx={{
                marginBottom: "8px",
                color: "#333",
                fontWeight: "500",
              }}
            >
              Please provide the reason for rejection:
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "#666",
                fontStyle: "italic",
              }}
            >
              Remarks must be between 10 and 255 characters.
            </Typography>
          </Box>
          <TextField
            autoFocus
            label="Remarks"
            type="text"
            fullWidth
            multiline
            rows={4}
            value={remarks}
            onChange={(e) => handleRemarksChange(e.target.value)}
            placeholder="Enter detailed reason for rejection (minimum 10 characters, maximum 255 characters)..."
            variant="outlined"
            error={!!remarksError}
            helperText={
              remarksError ||
              `${remarks.trim().length}/255 characters` +
                (remarks.trim().length > 0
                  ? ` (${
                      remarks.trim().length < 10
                        ? `${10 - remarks.trim().length} more required`
                        : "valid length"
                    })`
                  : "")
            }
            sx={{
              "& .MuiOutlinedInput-root": {
                "&:hover fieldset": {
                  borderColor: "#137e81",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#137e81",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#137e81",
              },
              "& .MuiFormHelperText-root": {
                color: remarksError ? "#d32f2f" : "#666",
              },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px", gap: "8px" }}>
          <Button
            onClick={handleCancelRemarks}
            color="secondary"
            variant="outlined"
            sx={{
              borderColor: "#6c757d",
              color: "#6c757d",
              "&:hover": {
                borderColor: "#545b62",
                backgroundColor: "rgba(108, 117, 125, 0.04)",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitRemarks}
            color="primary"
            variant="contained"
            disabled={
              !remarks.trim() ||
              remarks.trim().length < 10 ||
              remarks.trim().length > 255
            }
            sx={{
              backgroundColor: "#137e81",
              "&:hover": {
                backgroundColor: "#0f6c6f",
              },
              "&:disabled": {
                backgroundColor: "#cccccc",
                color: "#666666",
              },
            }}
          >
            Submit Rejection
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HouseHold;
